import type { Editor } from "@repo/fika-blog/src/tiptap/core"
import type { Bookmark } from "@repo/fika-shared/src/loader/bookmark-schema.js"
import { createMemo, createSignal, Show } from "solid-js"
import { useAppContext } from "@/context/app"
import { Box } from "@/designSystem/components/box"
import { Icon } from "@/designSystem/components/icon"
import { StoryDetail } from "@/pages/stories/frame"
import { minimizeButtonClass, rightPanelRecipe } from "./rightPanel.css"

type Props = {
  editor: Editor
  bookmark?: Bookmark | null
}

export function RightPanel(props: Props) {
  const [open, setOpen] = createSignal(true)
  const { db } = useAppContext()
  const getStory = createMemo(() => {
    if (!props.bookmark) return null
    return db.story.get(props.bookmark.story_id)
  })

  return (
    <Show when={getStory()}>
      {story => (
        <Box class={rightPanelRecipe({ open: open() })}>
          <button
            type="button"
            class={minimizeButtonClass}
            onClick={() => setOpen(!open())}
            title={open() ? "minimize" : "maximize"}
          >
            <Icon name={open() ? "menu" : "x"} size="18" />
          </button>
          <Show when={open()}>
            <StoryDetail story={story()} />
          </Show>
        </Box>
      )}
    </Show>
  )
}
